(function () {
    'use strict';

    // downloads module
    var module = angular.module('uwAgenda.downloads', [
        'uwAgenda.help',
        'uwAgenda.global'
    ]);

    // what report should be exported
    module.constant('ReportType', {
        "Agenda": { name: "Agenda", value: 0 }, // appointments & free times
        "Appointment": { name: "Appointment", value: 1 }, // only appointments
        "Task": { name: "Task", value: 2 }, // daytasks
        "CallMessage": { name: "CallMessage", value: 3 }, // calls & messages
        "User": { name: "User", value: 4 }, // users
        "Email": { name: "Email", value: 5 }, // emails
        "Chart": { name: "Chart", value: 6 } // charts
    });

    module.config(['$stateProvider', 'HelpCategoryEnum', DownloadsConfig]);

    function DownloadsConfig($stateProvider, HelpCategoryEnum) {
        $stateProvider
       .state('Home.Downloads', {
           url: 'Downloads',
           templateUrl: '/app/downloads/templates/downloads.template.html',
           resolve: {
               deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                   return $ocLazyLoad.load({
                       name: 'uwAgenda Downloads',
                       serie: true,
                       insertBefore: '#ng_load_plugins_before',
                       files: [
                           '/assets/lib/lazy-loaded/profile.css',
                           '/assets/lib/lazy-loaded/todo-2.min.css',

                           '/assets/lib/lazy-loaded/todo-2.min.js',
                           '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                           '/assets/lib/lazy-loaded/profile.min.js'
                       ]
                   });
               }]
           },
           data: {
               requiresLogin: true
           },
           ncyBreadcrumb: {
               label: "{{'download' | translate}}"
           }
       })
       .state('Home.Downloads.Agenda', {
           url: '/Agenda',
           templateUrl: '/app/downloads/templates/download-agenda.template.html',
           controller: 'DownloadAgendaController',
           controllerAs: 'vm',
           resolve: {
           },
           params: {
               helpCategory: HelpCategoryEnum.AgendaDownload
           },
           data: {
               requiresLogin: true
           },
           ncyBreadcrumb: {
               label: "{{'agenda_downloads' | translate}}"
           }
       })
       .state('Home.Downloads.Popular', {
           url: '/Popular',
           templateUrl: '/app/downloads/templates/download-popular.template.html',
           resolve: {
           },
           params: {
               helpCategory: HelpCategoryEnum.PopularDownload
           },
           data: {
               requiresLogin: true
           },
           ncyBreadcrumb: {
               label: "{{'popular_downloads' | translate}}"
           }
       });
    }
})();